import {Survey, SurveyPageProcessorCommand} from 'core/SurveyModels'
import {
  SurveyPageProcessor,
  SurveyPageProcessorMeta,
  SurveyPageProcessorResponse
} from 'core/builder/processors/SurveyPageProcessor'
import {
  SurveyPageProcessorAlert,
  SurveyPageProcessorLog,
  SurveyPageProcessorTemplate,
  SurveyPageProcessorTest
} from './processors'

export class SurveyPageProcessorFactory {
  private readonly commands: Partial<
    Record<SurveyPageProcessorCommand, typeof SurveyPageProcessor>
  > = {
    log: SurveyPageProcessorLog,
    test: SurveyPageProcessorTest,
    template: SurveyPageProcessorTemplate,
    alert: SurveyPageProcessorAlert
  }

  constructor(
    extend?: Partial<
      Record<SurveyPageProcessorCommand, typeof SurveyPageProcessor>
    >
  ) {
    this.commands = {
      ...this.commands,
      ...extend
    }
  }

  process(
    cmd: SurveyPageProcessorCommand,
    survey: Survey,
    meta: SurveyPageProcessorMeta
  ): Promise<SurveyPageProcessorResponse> {
    if (!this.commands[cmd]) return Promise.resolve({survey, canProceed: true})
    return this.commands[cmd]!.instance(survey, meta).process()
  }
}
